"use client";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <html lang="ru">
      <body
        style={{
          margin: 0,
          minHeight: "100vh",
          display: "grid",
          placeItems: "center",
          fontFamily: "Segoe UI, Noto Sans, sans-serif",
          background: "#f5f5f4",
          color: "#1c1917",
        }}
      >
        <div style={{ maxWidth: 420, padding: 24, display: "grid", gap: 12 }}>
          <h1 style={{ margin: 0, fontSize: "1.35rem" }}>Мира упала при загрузке</h1>
          <p style={{ margin: 0, color: "#78716c" }}>
            {error.message || "Неизвестная ошибка"}
          </p>
          <button
            type="button"
            onClick={reset}
            style={{
              border: "none",
              borderRadius: 8,
              padding: "10px 12px",
              background: "#d97706",
              color: "#1c1917",
              fontWeight: 600,
              cursor: "pointer",
            }}
          >
            Повторить
          </button>
        </div>
      </body>
    </html>
  );
}
